// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3LIM_","dragIcon":"SortableItem_dragIcon__3z35F","disabled":"SortableItem_disabled__r_fb5"};